import type { FC, SVGProps } from 'react';

// Lucide "anchor" scaled down inside Lucide "ban" (prohibition sign).
// The anchor stroke is widened by 1/scale so it matches the ring's visual weight.
export const AnchorBanIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle cx='12' cy='12' r='10' />
    <g transform='translate(12 12) scale(0.55) translate(-12 -12)' strokeWidth='3'>
      <path d='M12 6v16' />
      <path d='m19 13 2-1a9 9 0 0 1-18 0l2 1' />
      <path d='M9 11h6' />
      <circle cx='12' cy='4' r='2' />
    </g>
    <path d='M4.929 4.929 19.07 19.071' />
  </svg>
);
